import { Select } from "antd";
import { useEffect } from "react";

export default function CrrDropDown(props) {
  const {
    qnId = "", //to check if the page using the component is pre-assessment
    selectField,
    placeholderText,
    onChange = "",
    defaultValue,
    form,
    options,
    disabled,
    setValue,
    value,
    multi_resp,
    answer,
    setselectField,
    allowClear,
  } = props;

  const formatResponse = (value) => {
    return { question_id: qnId, opted_answer_id: value };
  };

  useEffect(() => {
    setValue(defaultValue || answer?.opted_answer_id);
  }, [defaultValue, answer]);

  useEffect(() => {
    if (answer) {
      form.setFieldsValue({
        [qnId]: answer?.opted_answer_id,
      });
      setValue(answer?.opted_answer_id);
    }
  }, [answer, qnId, form, setValue]);

  const onHandleChange = (value) => {
    setValue(value);

    if (qnId) {
      form.setFieldsValue({ [qnId]: value });
    }

    if (!form && onChange) {
      onChange(qnId ? formatResponse(value) : value);
    }
  };

  return (
    <Select
      onFocus={() => setselectField && setselectField(true)}
      className="login-input"
      mode={multi_resp && "multiple"}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      dropdownClassName="form-dropdown"
      placeholder={!selectField && placeholderText}
      onChange={onHandleChange}
      onBlur={onHandleBlur}
      value={value}
      bordered={false}
      disabled={disabled}
      allowClear={allowClear}
    >
      {options &&
        options.map((op, i) => (
          <Select.Option key={i} value={op.value || op.name}>
            {op.name}
          </Select.Option>
        ))}
    </Select>
  );

  function onHandleBlur() {
    const selected = options.find((op) => op.value === value);
    if (onChange && value && form) {
      const newValue = qnId ? formatResponse(form.getFieldValue(qnId)) : value;
      if (!selected?.option_has_text) onChange(newValue); // restricting the submission without text input
    }
  }
}
